export function isDevMode() {
  return (
    process.env.ENV.includes('dev') ||
    process.env.ENV.includes('test') ||
    process.env.NODE_ENV === 'development'
  );
}
